import { ActivityRole } from '../../activity/lib/activity.interfaces';
import { ContractData } from '../../contract/lib/contract.interfaces';
import { Staff } from '../../staff/staff.model';

export enum ApplicationStatus {
  Pending = 'pending',
  Approved = 'approved',
  Rejected = 'rejected',
  PositionClosed = 'closed',
}

export enum CertaintyLevel {
  Certain = 'certain',
  Interested = 'interested',
}

export interface ActivityData {
  role: ActivityRole;
  staff: Staff;
  contractData: ContractData;
}

export interface OpenSpotsInformation {
  active: {
    [key in ActivityRole]: number;
  };
  numOpenSpots: number;
  openLabels: ActivityRole[];
  openSpots: {
    [key in ActivityRole]: number;
  };
  required: {
    [key in ActivityRole]: number;
  };
}
